import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { Locale } from 'next-intl';

export const defaultLocale = 'en';

export const routing = defineRouting({
  locales: ['es', 'en'],
  localePrefix: 'as-needed', 
  defaultLocale: defaultLocale,
});

export const routeKeys = [
  'work',
  'about',
  'services',
  'contact',
  // 'branding',
  // 'designConsulting',
  // 'visualization',
  'projects',
  'privacyPolicy',
  'presentation',
  'legalNote'
] as const;

export type RouteKey = (typeof routeKeys)[number];

export const sitemapStaticRouteKeys: {routeKey: RouteKey, priority: number, changeFrequency: "always" | "never" | "hourly" | "daily" | "weekly" | "monthly" | "yearly"}[] = [
  { routeKey: 'work', priority: 0.9, changeFrequency: 'weekly' },
  { routeKey: 'services', priority: 0.9, changeFrequency: 'monthly' },
  { routeKey: 'about', priority: 0.8, changeFrequency: 'yearly' },
  { routeKey: 'contact', priority: 0.8, changeFrequency: 'yearly' }
] as const;

export const localizedSlugs: Record<RouteKey, Record<Locale, string>> = {
  work: {
    en: 'our-work',
    es: 'proyectos',
  },
  about: {
    en: 'about',
    es: 'nosotros',
  },
  services: {
    en: 'services',
    es: 'servicios',
  },
  legalNote: {
    en: 'legal-note',
    es: 'aviso-legal',
  },
  contact: {
    en: 'contact',
    es: 'contacto',
  },
  projects: {
    en: 'projects',
    es: 'proyecto',
  },
  privacyPolicy: {
    en: 'privacy-policy',
    es: 'politica-privacidad',
  },
  presentation: {
    en: 'presentation',
    es: 'presentacion',
  }
};

// navigation helpers
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);

// Custom getPathname to resolve based on route key and locale
export function getLocalizedPathname(
  routeKey: keyof typeof localizedSlugs,
  locale: 'en' | 'es'
) {
  const slug = localizedSlugs[routeKey]?.[locale];
  if (!slug) {
    throw new Error(
      `Slug for route "${routeKey}" not defined for locale "${locale}"`
    );
  }
  return `/${locale === defaultLocale ? '' : locale + '/'}${slug}`;
}
